module.exports = __webpack_public_path__ + "static/media/cert_56.bda0060b.jpg";